import NotImplemented from "../../exceptions/not-implemented";
import Rule from "./rule";

export default class OncePerPlayRule extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return !ruleContext.isRuleApplied(this.constructor.name);
    }

    // eslint-disable-next-line no-unused-vars
    async apply(gameContext, ruleContext, eventConfiguration) {
        throw new NotImplemented();
    }
}
